export const GET_COMMENTS = 'get_comments';
export const GET_COMMENTS_SUCCESS = 'get_comments_success';
export const GET_COMMENTS_FAIL = 'get_comments_fail';
export const SELECT_COMMENT = 'select_comment';
export const START_DRAWING_COMMENT = 'start_drawing_comment';
export const FINISH_DRAWING_COMMENT = 'finish_drawing_comment';
export const CANCEL_DRAWING_COMMENT = 'cancel_drawing_comment';



// WEBPACK FOOTER //
// ./src/types/comments.jsx